/* Copyright (c) 2021-2023 Nordcloud Oy or its affiliates. All Rights Reserved. */

import { Button, ButtonProps, SVGIconProps, theme } from "@nordcloud/gnui";

export enum FILE_FORMAT_TYPE {
  JSON = "json",
  YAML = "yaml",
}

type DownloadDescriptorButtonProps = {
  templateFile: string;
  propsMap: Map<string, string>;
  fileFormat: FILE_FORMAT_TYPE;
  buttonName: string;
  fileName?: string;
  icon?: SVGIconProps["name"];
  severity?: ButtonProps["severity"];
};

const generateFileByProps = (
  templateFile: string,
  props: Map<string, string>
) => {
  let finalFile = templateFile;
  for (const key of props.keys()) {
    finalFile = finalFile.replaceAll(
      new RegExp(key, "g"),
      props.get(key) ?? ""
    );
  }
  return btoa(finalFile);
};

function DownloadDescriptorButton(props: DownloadDescriptorButtonProps) {
  const fileName = props.fileName
    ? `${props.fileName.replaceAll(/[^\w-]/g, "")}.${props.fileFormat}`
    : `default.${props.fileFormat}`;

  return (
    <Button
      // @ts-expect-error Button should be enhanced with download attribute;
      download={fileName}
      severity={props.severity ?? "high"}
      icon={props.icon ?? "save"}
      css={{
        marginRight: theme.spacing.spacing01,
      }}
      linkTo={`data:application/octet-stream;charset=utf-16le;base64,${generateFileByProps(
        props.templateFile,
        props.propsMap
      )}`}
    >
      {props.buttonName}
    </Button>
  );
}

export default DownloadDescriptorButton;
